module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Power of Being Known: A Heart-Centered Journey Connecting to Self, Earth, Lineage, and Love")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#a-letter-from-the-author"
    }
  }, [_vm._v("A Letter from the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-i-knowing-your-self-begins-by-knowing-your-cells"
    }
  }, [_vm._v("Part I: Knowing Your Self Begins by Knowing Your Cells")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-1-you-are-one-cell-one-of-many"
    }
  }, [_vm._v("Chapter 1: You Are One Cell One of Many")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-2-you-receive-what-you-believe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: You Receive What You Believe")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#part-ii-heart-connection-connects-you-to-all",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Heart Connection Connects You to All")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-3-tend-to-your-heart-shes-welcoming-you-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Tend to Your Heart, She’s Welcoming You Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-4-return-to-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Return to Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-5-everything-is-energy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Everything Is Energy")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#part-iii-from-who-am-i-to-i-am",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: From ‘Who Am I?’ To I Am")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-6-generational-healing-creates-generational-wealth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Generational Healing Creates Generational Wealth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-7-unlock-the-alchemist-within-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Unlock the Alchemist Within You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-8-embody-the-truth-of-who-you-are",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Embody the Truth of Who You Are")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-9-and-the-journey-continues",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: And the Journey Continues")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0